export * from "./services/administrator-exists-service";
